var wFlag=true
if(window.innerWidth<750){
    wFlag=false
    $('.box6_video').attr({
        autoplay: true,
        loop: true
    });
}

function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

//提前加载图片
const preloadImages = () => {
    for(let i=1;i<27;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xtfc_box4_${i}.avif?v=1760933967`;
    }
};
preloadImages()

$(()=>{

    // 播放完显示封面
    $('.box1 video').on('ended', function() {
        $('.box1_mask').css({opacity:1});
    });

    setTimeout(() => {
        $('.box1_title').addClass('showup')
    }, 1000);

    showUp('.box2_title')

    var box3Swiper = new Swiper('.box3Swiper', {
        direction: wFlag?'vertical':'horizontal',
        slidesPerView: wFlag?1.7:1,
        centeredSlides: true,
        autoplay:wFlag?false:true,
        allowTouchMove:wFlag?false:true,
        pagination: {
            el: '.box3Swiper-pagination',
            clickable:true
        },
    })

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box3',
            start:'top top+=6%',
            end:'+=100%',
            pin:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 8);
                if(index>5){
                    box3Swiper.slideTo(2, 300);
                }else if(index>2){
                    box3Swiper.slideTo(1, 300);
                }else{
                    box3Swiper.slideTo(0, 300);
                }
            }
        })
    }

    showUp('.box4_title')
    showUp('.box4_item')
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=6%',
            end:'+=100%',
            scrub:1,
            pin:true,
            // markers:true,
            animation:gsap.timeline()
                .to('.box4_img2',{opacity:1,duration:0.4})
                .to({},{duration:0.2})
                .from('.box4_1',{opacity:0,duration:0.2})
                .to({},{duration:0.2})
        })

        //box5
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top top+=4%',
            end:'+=70%',
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 25);
                $('.box5_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xtfc_box4_${index+1}.avif?v=1760933967`) 
            }
        })
    
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top+=120% top+=4%',
            end:'+=30%',
            scrub:1,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                if(index>2){
                    $('.box5_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xtfc_box4_25.avif?v=1760933967`) 
                }else{
                    $('.box5_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xtfc_box4_26.avif?v=1760933967`) 
                }
            },
            animation:gsap.timeline()
                .to('.box5_img',{x:'22%'})
                .from('.box5_title',{opacity:0,y:'2rem'})
                .from('.box5_item',{opacity:0,y:'2rem'},'-=50%')
        })
    
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top top+=4%',
            end:'+=170%',
            pin:true
        })

        //box6
        showUp('.box6_title')
        var $video = $('.box6_video');
        ScrollTrigger.create({
            trigger:'.box6',
            start:'top top+=3%',
            end:'+=80%',
            scrub:true,
            pin:true,
            onUpdate:(self)=>{
                $video[0].currentTime = self.progress * 3;
                //console.log($video[0].duration)
            }
        })
    }else{
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=6%',
            end:'+=50%',
            scrub:1,
            pin:true,
            animation:gsap.timeline()
                .to('.box4_img2',{opacity:1})
                .to({},{duration:0.3})
        })

        showUp('.box5_content')
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top top+=6%',
            end:'+=50%',
            pin:true,
            // markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 25);
                $('.box5_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/xtfc_box4_${index+1}.avif?v=1760933967`) 
            }
        })

        showUp('.box6_title')
    }

    showUp('.box7_title')
    ScrollTrigger.create({
        trigger:'.box7_item',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .from('.box7_item div',{opacity:0,y:'2rem',stagger:0.2})
    })
 
    new Swiper('.box8Swiper1', {
        autoplay:true,
        pagination: {
            el: '.box8Swiper1-pagination',
            clickable:true
        },
    })

    new Swiper('.box8Swiper2', {
        autoplay:true,
        pagination: {
            el: '.box8Swiper2-pagination',
            clickable:true
        },
    })

    showUp('.box8_title')

    new Swiper('.box9Swiper', {
        autoplay:true,
        pagination: {
            el: '.box9Swiper-pagination',
            clickable:true
        },
    })

    showUp('.box9_title')
    showUp('.box10_title')

    new Swiper('.box10Swiper', {
        autoplay:true,
        pagination: {
            el: '.box10Swiper-pagination',
            clickable:true
        },
    })

    $('.box10_btn div').click(function(){
        var index = $(this).index()
        $(this).addClass('box10_active').siblings().removeClass('box10_active')
        $('.box10_content .box10_flag').eq(index).addClass('box10_show').siblings().removeClass('box10_show')
    })
})